import React from 'react';
import { CircleNotch, Trash } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

export const EmployeesBulkActionBar = ({
  selectedCount, onClear, onBulkDelete, bulkDeleting,
}) => {
  if (selectedCount === 0) return null;
  return (
    <Card className="border-indigo-200 bg-indigo-50">
      <CardContent className="py-3 flex items-center justify-between">
        <span className="text-sm font-medium text-indigo-800">
          {selectedCount} employee{selectedCount > 1 ? 's' : ''} selected
        </span>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={onClear} data-testid="emp-clear-selection-btn">
            Clear
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            disabled={bulkDeleting}
            data-testid="emp-bulk-delete-btn"
          >
            {bulkDeleting
              ? <CircleNotch size={14} className="mr-1 animate-spin" />
              : <Trash size={14} className="mr-1" />}
            Delete {selectedCount}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmployeesBulkActionBar;
